export const sliderData = [
    {
        image: require('../images/banner_1.jpg'),
        heading: "Slide One",
        desc: "This is the description of the slide one.",
    },
    {
        image: require('../images/banner_2.jpg'),
        heading: "Slide Two",
        desc: "This is the description of the slide two.",
    },
    {
        image: require('../images/banner_3.jpg'),
        heading: "Slide Three",
        desc: "This is the description of the slide Three.",
    }
]

export const CategoryData = [
    {
        image: require('../images/shoes.png'),
        Category: "Shoes",
    },
    {
        image: require('../images/wallet.png'),
        Category: "Wallet",
    },
    {
        image: require('../images/bag2.png'),
        Category: "Bags",
    },
    {
        image: require('../images/clothes.png'),
        Category: "Clothes",
    },
    {
        image: require('../images/perfume.png'),
        Category: "Perfumes",
    }
]

export const AccessoriesData = [
    {
        image: require('../images/watches.png'),
        Category: "Watches",
        Name: "Watches",
    },
    {
        image: require('../images/Jewellery.png'),
        Category: "Jewellery",
        Name: "Jewellery",
    },
    {
        image: require('../images/glasses.png'),
        Category: "Glasses",
        Name: "Glasses",
    },
    {
        image: require('../images/glasses.png'),
        Category: "Unisex",
        Name: "All Unisex",
    }
]

export const MenShoesSubcategoryData = [
    {
        image: require('../images/shoes.png'),
        Subcategory: "loafers",
    },
    {
        image: require('../images/shoes.png'),
        Subcategory: "sneakers",
    },
    {
        image: require('../images/shoes.png'),
        Subcategory: "slides",
    },
    {
        image: require('../images/shoes.png'),
        Subcategory: "yeezys",
    }
]

export const MenBagsSubcategoryData = [
    {
        image: require('../images/wallet.png'),
        Subcategory: "messengers",
    },
    {
        image: require('../images/wallet.png'),
        Subcategory: "duffles",
    },
    {
        image: require('../images/wallet.png'),
        Subcategory: "back-packs",
    },
    {
        image: require('../images/wallet.png'),
        Subcategory: "slings",
    },
    {
        image: require('../images/wallet.png'),
        Subcategory: "satchels",
    },
    {
        image: require('../images/wallet.png'),
        Subcategory: "belt-bags",
    }
]

export const WomenShoesSubcategoryData = [
    {
        image: require('../images/shoes.png'),
        Subcategory: "espadrilles",
    },
    {
        image: require('../images/shoes.png'),
        Subcategory: "sneakers",
    },
    {
        image: require('../images/shoes.png'),
        Subcategory: "slides",
    },
    {
        image: require('../images/shoes.png'),
        Subcategory: "heels",
    },
    {
        image: require('../images/shoes.png'),
        Subcategory: "sandals",
    }
]

export const WomenBagsSubcategoryData = [
    {
        image: require('../images/shoes.png'),
        Subcategory: "totes",
    },
    {
        image: require('../images/shoes.png'),
        Subcategory: "shoulder-cross-body",
    },
    {
        image: require('../images/shoes.png'),
        Subcategory: "mini-bags",
    },
    {
        image: require('../images/shoes.png'),
        Subcategory: "clutches",
    }
]